'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isNextMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isNextMonth.js
// module id = 549
// module chunks = 0